import React, { FC, useEffect, useId, useState } from 'react';
import { DisclosureContent, DisclosureTrigger, TriggerChevron } from './styles';

type CodeEntryDisclosureProps = {
  label: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};

export const CodeEntryDisclosure: FC<CodeEntryDisclosureProps> = ({
  label,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  useEffect(() => {
    if (defaultOpen) {
      setIsOpen(true);
    }
  }, [defaultOpen]);

  return (
    <>
      <DisclosureTrigger
        type="button"
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={() => setIsOpen((prev) => !prev)}
        data-testid="codeEntryDisclosureTrigger"
      >
        {label}
        <TriggerChevron $isOpen={isOpen} aria-hidden="true" />
      </DisclosureTrigger>
      {isOpen ? (
        <DisclosureContent id={contentId} role="region" aria-label={label}>
          {children}
        </DisclosureContent>
      ) : null}
    </>
  );
};
